import React, { Component } from 'react';
import ReviewLabelBut from  "./review-label-but";
export default class feedbackOption extends Component {
	constructor(props) {
		super(props);
		this.state = {
      data: this.props.labelData,
			rating: this.props.rating,
			action: false
    };
	}
	
	componentDidUpdate(prevProps){

		if (prevProps.rating !== this.props.rating) {
			this.setState({
				data: this.props.labelData,
				rating: this.props.rating,
			})
		}

	}

  renderReviewLabelBut(){
    let FeedbackOption = this.state.data;
		var reviewPhraseDataArray = [];

		if(this.state.rating <= 2){
			FeedbackOption.forEach((data,index) =>{
				if(data.id >= 14){
					reviewPhraseDataArray.push(data);
				}
			})
		}else{
			FeedbackOption.forEach((data,index) =>{
				if(data.id < 14){
					reviewPhraseDataArray.push(data);
				}
			})
		}
		var reviewBlocks = reviewPhraseDataArray.map((label,index) => {
			return (
				<ReviewLabelBut submitReviewLabelData={this.props.submitReviewLabelData} action={this.state.action} labelName={label.option} id={label.id} index={index}></ReviewLabelBut>
			)
		})

		return (
			reviewBlocks
		);

	}

  render() {
      return (
        <div className="review-label-conten">
          {this.renderReviewLabelBut()}
        </div>
      )
  }
}    


// WEBPACK FOOTER //
// ./src/components/review/feedbackOption.js